import React from 'react';
import Header from './components/Header';
import HeroSection from './components/HeroSection';
import AboutSection from './components/AboutSection';
import GallerySection from './components/GallerySection';
import SpecialtiesSection from './components/SpecialtiesSection';
import FormationsSection from './components/FormationsSection';
import ContactSection from './components/ContactSection';
import Footer from './components/Footer';
import './App.css';

function App() {
  return (
    <div className="App">
      <Header />
      <HeroSection />
      <AboutSection />
      <GallerySection />
      <SpecialtiesSection />
      <FormationsSection />
      <ContactSection />
      <Footer />
    </div>
  );
}

export default App;